var _rect, _rect2, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgComputeIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 18,
    viewBox: "0 0 19 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 3.25,
    y: 2.75,
    width: 12.5,
    height: 12.5,
    rx: 3.25,
    stroke: "#B843EE",
    strokeWidth: 1.5
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 5.5,
    y: 5,
    width: 8,
    height: 8,
    rx: 2,
    fill: "#B843EE"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.75 0C7.30229 0 7.75 0.447715 7.75 1V2.33325H6.8335C6.458 2.33325 6.09459 2.38499 5.75 2.48173V1C5.75 0.447715 6.19772 0 6.75 0ZM3.15906 4.75H1.5C0.947715 4.75 0.5 5.19772 0.5 5.75C0.5 6.30228 0.947715 6.75 1.5 6.75H2.8335V6.33325C2.8335 5.77084 2.94957 5.23554 3.15906 4.75ZM2.8335 7.74993H1.5C0.947715 7.74993 0.5 8.19764 0.5 8.74993C0.5 9.30221 0.947715 9.74993 1.5 9.74993H2.8335V7.74993ZM2.8335 10.7501H1.5C0.947715 10.7501 0.5 11.1978 0.5 11.7501C0.5 12.3024 0.947715 12.7501 1.5 12.7501H2.98197C2.88524 12.4055 2.8335 12.0421 2.8335 11.6666V10.7501ZM5.75 15.5181V17C5.75 17.5523 6.19772 18 6.75 18C7.30228 18 7.75 17.5523 7.75 17V15.6666H6.83349C6.458 15.6666 6.09459 15.6148 5.75 15.5181ZM8.75 15.6666V17C8.75 17.5523 9.19772 18 9.75 18C10.3023 18 10.75 17.5523 10.75 17V15.6666H8.75ZM11.75 15.6666V17C11.75 17.5523 12.1977 18 12.75 18C13.3023 18 13.75 17.5523 13.75 17V15.3411C13.2645 15.5505 12.7292 15.6666 12.1668 15.6666H11.75ZM16.0184 12.7501H17.5C18.0523 12.7501 18.5 12.3024 18.5 11.7501C18.5 11.1978 18.0523 10.7501 17.5 10.7501H16.1668V11.6666C16.1668 12.0421 16.1151 12.4055 16.0184 12.7501ZM16.1668 9.74993H17.5C18.0523 9.74993 18.5 9.30221 18.5 8.74993C18.5 8.19764 18.0523 7.74993 17.5 7.74993H16.1668V9.74993ZM16.1668 6.75H17.5C18.0523 6.75 18.5 6.30228 18.5 5.75C18.5 5.19772 18.0523 4.75 17.5 4.75H15.8413C16.0508 5.23554 16.1668 5.77084 16.1668 6.33325V6.75ZM13.75 2.65878V1C13.75 0.447715 13.3023 0 12.75 0C12.1977 0 11.75 0.447715 11.75 1V2.33325H12.1668C12.7292 2.33325 13.2645 2.44931 13.75 2.65878ZM10.75 2.33325V1C10.75 0.447715 10.3023 0 9.75 0C9.19772 0 8.75 0.447715 8.75 1V2.33325H10.75Z",
    fill: "#B843EE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgComputeIcon);
export default __webpack_public_path__ + "static/media/Compute_icon.ccaa178dc16bd83a1ed580133ca73e21.svg";
export { ForwardRef as ReactComponent };